// 기존 성능 모니터링 강화 (서비스 영향 없음)
export default ({ app }, inject) => {
  if (process.client) {
    const performanceMonitor = {
      // 페이지 로딩 시간 측정
      measurePageLoad () {
        if (window.performance && window.performance.timing) {
          const timing = window.performance.timing
          const loadTime = timing.loadEventEnd - timing.navigationStart
          console.log(`📊 페이지 로딩 시간: ${loadTime}ms`)
          return loadTime
        }
      },

      // 메모리 사용량 모니터링
      measureMemory () {
        if (window.performance && window.performance.memory) {
          const memory = window.performance.memory
          const memoryInfo = {
            used: Math.round(memory.usedJSHeapSize / 1048576),
            total: Math.round(memory.totalJSHeapSize / 1048576),
            limit: Math.round(memory.jsHeapSizeLimit / 1048576)
          }
          console.log('🧠 메모리 사용량:', memoryInfo)
          return memoryInfo
        }
      },

      // API 응답 시간 측정
      measureApiResponse (url, startTime) {
        const endTime = performance.now()
        const duration = endTime - startTime
        console.log(`🌐 API 응답 시간 [${url}]: ${duration.toFixed(2)}ms`)
        return duration
      },

      // 컴포넌트 렌더링 시간 측정
      measureComponentRender (componentName) {
        const startTime = performance.now()
        return {
          end: () => {
            const endTime = performance.now()
            const duration = endTime - startTime
            console.log(`⚡ 컴포넌트 렌더링 [${componentName}]: ${duration.toFixed(2)}ms`)
            return duration
          }
        }
      }
    }

    // 전역 주입 (기존 코드 영향 없음)
    inject('perf', performanceMonitor)

    // 자동 모니터링 (개발 환경에서만)
    if (process.env.NODE_ENV === 'development') {
      // 페이지 로드 완료 시 자동 측정
      window.addEventListener('load', () => {
        setTimeout(() => {
          performanceMonitor.measurePageLoad()
          performanceMonitor.measureMemory()
        }, 1000)
      })

      // 5분마다 메모리 사용량 체크
      setInterval(() => {
        performanceMonitor.measureMemory()
      }, 300000)
    }
  }
}
